<template>
  <TableLineWrapper :isBottomBorderNotShow="index === rowLength - 1">
    <TableInfoLine :value="String(order.ord)" />
    <TableInfoLine :value="formatDate(order.senddate)" />
    <TableInfoLine :value="formatDate(order.duedate)" />
    <TableInfoLine :value="order.reference" />
    <TableInfoLine class="ma-2">
      <StatusLabel :status="order.Status.statusNameForCust"
    /></TableInfoLine>
    <TableInfoLine
      :value="'₪' + formatPrice(totalAmountWithDiscount).toLocaleString()"
    />
    <TableActions :document="order" />
  </TableLineWrapper>
</template>

<script>
import moment from "moment";
import TableInfoLine from "../../../UI/tabels/TableInfoLine.vue";
import TableLineWrapper from "../../../UI/tabels/TableLineWrapper.vue";
import StatusLabel from "../../../UI/tabels/StatusLabel.vue";
import TableActions from "../../../UI/tabels/TableActions.vue";
export default {
  components: { TableInfoLine, TableLineWrapper, StatusLabel, TableActions },
  props: {
    order: {
      type: Object,
    },
    rowLength: {
      type: Number,
    },
    index: {
      type: Number,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatPrice(price) {
      if (!isNaN(price)) {
        return Number(price).toFixed(1);
      }
      return "0";
    },
  },
  computed: {
    totalAmountWithDiscount() {
      // if (this.customerDiscountPercent !== 0) {
      //   return this.priceInludeDiscount + this.totalVatWithDiscount;
      // }
      return this.order?.amount;
    },
    customerDiscountPercent() {
      return (
        this.order?.Customer?.discountPrecent ||
        this.order?.User?.Customer?.discountPrecent ||
        0
      );
    },
    priceInludeDiscount() {
      return (
        this.order.totalWithOutVat *
        -1 *
        ((this.customerDiscountPercent - 100) / 100)
      );
    },
    totalVatWithDiscount() {
      if (this.customerDiscountPercent !== 0) {
        const discountedPrice = this.priceInludeDiscount;
        return (discountedPrice * this.order.tax) / 100;
      }
      return this.order.totalVat;
    },
  },
};
</script>

<style scoped lang="scss"></style>
